import React, { JSXElementConstructor, ReactElement, ReactNode } from 'react';
import Tooltip from 'carbon-react/lib/components/tooltip';
import { TooltipPositions } from 'carbon-react/lib/components/tooltip/tooltip.config';

interface Props {
  disableTooltip: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: ReactElement<any, string | JSXElementConstructor<any>>;
  tooltipMessage?: ReactNode;
  position?: TooltipPositions;
}
export const TooltipContainer = ({ disableTooltip, children, tooltipMessage, position = 'bottom' }: Props) => {
  if (disableTooltip) {
    return <>{children}</>;
  }

  return (
    <Tooltip message={tooltipMessage} position={position}>
      {children}
    </Tooltip>
  );
};
